<cdk-accordion>
  <svi-accordion-item>
    <div class="info-panel">
      <p class="hint">

      </p>
    </div>
  </svi-accordion-item>
</cdk-accordion>